/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TipoStrutturaResDto } from '../../models/tipo-struttura-res-dto';

export interface TipiStruttureControllerFindManyTipiStruttura$Params {}

export function tipiStruttureControllerFindManyTipiStruttura(
  http: HttpClient,
  rootUrl: string,
  params?: TipiStruttureControllerFindManyTipiStruttura$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<TipoStrutturaResDto>>> {
  const rb = new RequestBuilder(
    rootUrl,
    tipiStruttureControllerFindManyTipiStruttura.PATH,
    'get',
  );
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TipoStrutturaResDto>>;
      }),
    );
}

tipiStruttureControllerFindManyTipiStruttura.PATH = '/tipiStrutture';
